import React from 'react';
import { Button } from 'ui-kit';
import PropTypes from 'prop-types';
import './SignInOption.scss';
export default function SignInOption({ label, actionLabel, connected, onClick, disabled = false }) {
  return (
    <p className="SignInOption">
      {connected ? `Connected with ${label}` : `Sign in with ${label}`}
      <Button onClick={onClick} disabled={disabled}>
        {actionLabel ?? (connected ? 'Disconnect' : 'Add')}
      </Button>
    </p>
  );
}

SignInOption.propTypes = {
  label: PropTypes.string,
  connected: PropTypes.bool,
  onClick: PropTypes.func,
  actionLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

SignInOption.defaultProps = {
  onClick: () => null,
  connected: false,
};
